module.exports = __webpack_public_path__ + "img/hyphen-svgrepo-com.3e70424c.svg";